import { Brand } from 'components/common/types/Deal.types';
import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterBrandProps } from './FilterBrand.types';
import { useLoadLookup } from '../useLoadLookup';

const FilterBrand: React.FC<FilterBrandProps> = ({ brand, changeFilters }) => {
  const { onLoadBrands } = useLoadLookup();

  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  const handleSelectBrand: SelectHandler<Brand> = (_, value: Brand): void => {
    changeFilters({ brand: value });
  };

  return (
    <AsyncSelect
      name="brand"
      selectedValue={brand}
      loadData={onLoadBrands}
      onSelect={handleSelectBrand}
      placeholder="Search brand"
      dataTestId="brand-filter"
      textKey="name"
      dataPendoId={getPendoDataId('Brand filter')}
    />
  );
};

export default FilterBrand;
